module.exports = __webpack_public_path__ + "static/img/avater.025930aa.jpg";